import { render, staticRenderFns } from "./prizeHistory.vue?vue&type=template&id=1846741f&scoped=true&"
import script from "./prizeHistory.vue?vue&type=script&lang=js&"
export * from "./prizeHistory.vue?vue&type=script&lang=js&"
import style0 from "./prizeHistory.vue?vue&type=style&index=0&id=1846741f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1846741f",
  null
  
)

export default component.exports